export default __webpack_public_path__ + "static/media/offline-tick.4b187697.svg";